<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ 'settings.billing.upfrontLicensePurchase.title' | translate }}</h2>
      <p class="app-dialog__subtitle" *ngIf="data.subscriptionPeriod">
        {{ data.subscriptionPeriod === 'yearly' ? ('settings.billing.upfrontLicensePurchase.yearlySubscription' | translate) : ('settings.billing.upfrontLicensePurchase.monthlySubscription' | translate) }}
      </p>
    </div>
    <button mat-icon-button type="button" (click)="close()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <div class="form">
      <p class="subdomains-info">
        <mat-icon>info</mat-icon>
        {{ 'settings.billing.licensesCoverAllDomainsInfo' | translate }}
      </p>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'settings.billing.upfrontLicensePurchase.numberOfLicenses' | translate }}</mat-label>
        <input matInput type="number" [(ngModel)]="employeeCount" (ngModelChange)="calculatePrice()" [min]="minLicenseCount" />
      </mat-form-field>
      <mat-error *ngIf="hasLicenseCountError">
        {{ 'settings.billing.upfrontLicensePurchase.minLicenseError' | translate }}
      </mat-error>

      <div class="price-summary" *ngIf="calculatedPrice > 0">
        <p class="subdomains-info">
          <mat-icon>info</mat-icon>
          {{ 'settings.billing.licensesCoverAllDomainsInfo' | translate }}
        </p>
        <div class="price-row">
          <div class="price-row-content">
            <div class="price-row-header">
              <span class="price-label">{{ 'settings.billing.upfrontLicensePurchase.totalPrice' | translate }}:</span>
              <span class="price-value">{{ calculatedPriceWithVat | number:'1.2-2' }} {{ data.currency }}</span>
            </div>
          </div>
        </div>
        <div class="price-details">
          <div class="price-detail-item">
            <div class="price-detail-row">
              <span>{{ 'settings.billing.upfrontLicensePurchase.numberOfLicenses' | translate }}:</span>
              <span>{{ employeeCount }}</span>
            </div>
          </div>
          <div class="price-detail-row">
            <span>{{ 'settings.billing.upfrontLicensePurchase.pricePerLicense' | translate }}:</span>
            <span>{{ pricePerLicense }} {{ data.currency }}</span>
          </div>
          <div class="price-detail-row" *ngIf="hasVat">
            <span>VAT ({{ data.vatRate }}%):</span>
            <span>{{ vatAmount }} {{ data.currency }}</span>
          </div>
        </div>
        <div class="disclaimer-inline" *ngIf="data.billingMode !== 'legacy'">
          {{ 'settings.billing.upfrontLicensePurchase.disclaimer' | translate }}
        </div>
      </div>
    </div>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="close()">{{ 'cancel' | translate }}</button>
    <button mat-raised-button color="primary" type="button" (click)="submit()" [disabled]="sendingRequest || data.price <= 0">
      {{ sendingRequest ? ('saving' | translate) : ('settings.billing.upfrontLicensePurchase.proceed' | translate) }}
    </button>
  </footer>
</div>
